import React from 'react';
import { NavLink } from 'react-router';
import '../App.css'; 

const ResearchSidebar = () => {
  return (
    <nav className="dashboard-sidebar">
      <NavLink 
        to="/research-portal" 
        end 
        className={({ isActive }) => isActive ? "sidebar-link active" : "sidebar-link"}>
        Home
      </NavLink>
      
      <NavLink 
        to="/research-portal/account" 
        className={({ isActive }) => isActive ? "sidebar-link active" : "sidebar-link"}>
        Account
      </NavLink>
      
      <NavLink 
        to="/research-portal/surveys" 
        className={({ isActive }) => isActive ? "sidebar-link active" : "sidebar-link"}>
        Surveys
      </NavLink>
      
      <NavLink 
        to="/research-portal/data" 
        className={({ isActive }) => isActive ? "sidebar-link active" : "sidebar-link"}>
        Data
      </NavLink>

      <NavLink 
        to="/research-portal/add-remove-products" 
        className={({ isActive }) => isActive ? "sidebar-link active" : "sidebar-link"}>
        Add/Remove Products
      </NavLink>

      <NavLink 
        to="/research-portal/manage-popups" 
        className={({ isActive }) => isActive ? "sidebar-link active" : "sidebar-link"}>
        Manage Popups
      </NavLink>
    </nav>
  );
};

export default ResearchSidebar;